/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import localeES from '@angular/common/locales/es';
registerLocaleData(localeES);
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NbPasswordAuthStrategy, NbAuthModule, NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { MyInterceptor } from './@theme/interceptors/my.interceptor';
import {MatDialogModule, MatCheckboxModule} from '@angular/material';
import {CustomDialogComponent} from './custom_components/custom-dialog/custom-dialog.component';
import {ModalAddActividadComponent} from './custom_components/modal-add-actividad/modal-add-actividad.component';
import {ModalAddSocioComponent} from './custom_components/modal-add-socio/modal-add-socio.component';
import { ModalAddEntidadActividadesComponent } from './custom_components/modal-add-entidad-actividades/modal-add-entidad-actividades.component'
import { ModalAddIngresosGastosActividadesComponent } from './custom_components/modal-add-ingresos-gastos-actividades/modal-add-ingresos-gastos-actividades.component';
import { AuthGuard } from './@core/seguridad/auth-guard.service';
import {AccionesAddEntidadesComponent} from './custom_components/AccionesAddEntidades/AccionesAddEntidades.component';
import { PagesModule } from './pages/pages.module';
import { PublicModule } from './public/public.module';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ModalCheckBoxEntidadActComponent } from './custom_components/modal-check-box-entidad-act/modal-check-box-entidad-act.component';
import { NbCheckboxModule } from '@nebular/theme';
import { NgbdModalConfig } from './custom_components/modal-add-red-social-entidad/modal-add-red-social-entidad';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { RouterModule } from '@angular/router';
import { ModalQuieroSerSocioComponent } from './custom_components/modal-quiero-ser-socio/modal-quiero-ser-socio.component';
import { CookieService } from 'ngx-cookie-service';
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { AvatarModule } from 'ngx-avatar';



@NgModule({
  declarations: [AppComponent,
    CustomDialogComponent,
    ModalAddActividadComponent,
    ModalAddSocioComponent,
    ModalQuieroSerSocioComponent,
    ModalAddEntidadActividadesComponent,
    ModalAddIngresosGastosActividadesComponent,
    AccionesAddEntidadesComponent,
    ModalCheckBoxEntidadActComponent,
    NgbdModalConfig
    

  ],
  imports: [
    BrowserModule,
    RecaptchaModule,
    MatDialogModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AngularEditorModule,
    AppRoutingModule,
    PagesModule,
    PublicModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    FroalaEditorModule.forRoot(), 
    FroalaViewModule.forRoot(),
    Ng2SmartTableModule,
    AvatarModule,
    MatCheckboxModule,
    NbCheckboxModule,
    NbDateFnsDateModule.forRoot({
      parseOptions: { awareOfUnicodeTokens: false },
      formatOptions: { awareOfUnicodeTokens: false },
      format: 'dd-MM-yyyy'
    }),
    NbDateFnsDateModule.forChild({ format: 'dd-MM-yyyy' }),   

  ],
  exports:[FroalaEditorModule, 
    FroalaViewModule],
  entryComponents: [
    CustomDialogComponent,
    ModalAddActividadComponent,
    ModalAddSocioComponent,
    ModalQuieroSerSocioComponent,
    ModalAddEntidadActividadesComponent,
    ModalAddIngresosGastosActividadesComponent,
    AccionesAddEntidadesComponent,
    ModalCheckBoxEntidadActComponent,
  
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthGuard,
    CookieService,
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: HTTP_INTERCEPTORS, useClass: MyInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: '6Lcu3aEmAAAAAD5-4tXNKE41Wsn-GTLRHMLdRqIm' } as RecaptchaSettings, // 6LfYXtoUAAAAALhr8rbX6PknGNUWjUd9VKAx7n9c //6LdjkEEmAAAAAP8KV7mTPddV9DzAjOLFIW7l-JA0
    }
  ],
})
export class AppModule {
}
